import formatDateOnly from '~support-at-home/lib/formatDateOnly';

import { Column } from '~components/table-view';

/**
 * Column definitions for the Services Australia approved services import result tables (TAV-3420).
 *
 * Dates here are bare calendar dates (YYYY-MM-DD), so they go through formatDateOnly rather than a
 * datetime parser, which would shift the day.
 */

const period: Column = {
  id: 'period',
  header: 'Period',
  type: 'text',
  // Spelled out rather than formatDateOnly's dash placeholder: an approval with no end date is a
  // normal, open-ended approval and should read as one.
  deriveValue: (row) =>
    `${row.start_date ? formatDateOnly(row.start_date) : 'no start date'} - ${
      row.end_date ? formatDateOnly(row.end_date) : 'no end date'
    }`,
};

const approvalType: Column = {
  id: 'approval_type',
  header: 'Approval type',
  type: 'text',
  deriveValue: (row) => row.approval_type ?? '',
};

// Created / Updated: approved services the import actually wrote.
export const importItemColumns: Column[] = [
  {
    id: 'client_name',
    header: 'Client',
    type: 'text',
  },
  {
    id: 'service_name',
    header: 'Service',
    type: 'text',
  },
  approvalType,
  period,
];

// Skipped: approved services the import fetched but could not write.
export const importSkippedColumns: Column[] = [
  {
    id: 'client_name',
    header: 'Client',
    type: 'text',
    // A skipped approval usually has no matching client, so name the care recipient Services
    // Australia sent instead.
    deriveValue: (row) => {
      if (row.client_name) return row.client_name;
      if (row.care_recipient_id) return `Care recipient ${row.care_recipient_id}`;
      return 'Unmatched';
    },
  },
  {
    id: 'service_name',
    header: 'Service',
    type: 'text',
    deriveValue: (row) => row.service_name ?? row.sah_service_id ?? 'Unknown',
  },
  approvalType,
  period,
  {
    id: 'reason',
    header: 'Reason',
    type: 'text',
    // A sentence, so it wraps rather than pushing the table past the modal (_configs.scss).
    classNames: { column: 'sah-import-reason-cell' },
  },
];
